// components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">
                    Samir Dutta
                    {/* <span className="bengali-text" style={{ fontSize: '0.8rem', display: 'block', marginTop: '-5px', opacity: 0.8 }}>
                        সমীর দত্ত
                    </span> */}
                </Link>
                <button className="navbar-toggle" onClick={toggleMenu}>
                    <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                </button>
                <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
                    <li>
                        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
                            About
                        </Link>
                    </li>
                    <li>
                        <Link to="/gallery" className={location.pathname === '/gallery' ? 'active' : ''}>
                            Gallery
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/cv" className={location.pathname === '/cv' ? 'active' : ''}>
                            CV
                        </Link>
                    </li> */}
                    <li>
                        <Link to="/school" className={location.pathname === '/school' ? 'active' : ''}>
                            Art School
                        </Link>
                    </li>
                    <li>
                        <Link to="/exhibition" className={location.pathname === '/exhibition' ? 'active' : ''}>
                            Exhibitions
                        </Link>
                    </li>
                    <li>
                        <Link to="/commission" className={location.pathname === '/commission' ? 'active' : ''}>
                            Customized Order
                        </Link>
                    </li>
                    <li>
                        <Link to="/testimonials" className={location.pathname === '/testimonials' ? 'active' : ''}>
                            Testimonials
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>
                            Contact
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;